export default [
  {
    title: "dashboards",
    icon: "HomeIcon",
    route: "dashboard",
    module: "Dashboards",
  },
  {
    title: "companies",
    icon: "DatabaseIcon",
    route: "companies",
    module: "Compañías",
  },
  {
    title: "binnacle",
    icon: "ArchiveIcon",
    children: [
      {
        title: "binnacle-emails",
        icon: "",
        route: "BinnacleEmails",
        module: "Configuraciones",
      },
      {
        title: "binnacle-logins",
        icon: "",
        route: "BinnacleLogins",
        module: "Configuraciones",
      },
      {
        title: "binnacle-files-storages",
        icon: "",
        route: "BinnacleFilesStorage",
        module: "Configuraciones",
      },
      {
        title: "logs-systems",
        icon: "",
        route: "LogsSystem",
        module: "Configuraciones",
      },
      {
        title: "user-logs-systems",
        icon: "",
        route: "UserLogsSystem",
        module: "Configuraciones",
      },
    ],
  },
  {
    title: "qr",
    icon: "MaximizeIcon",
    route: "qr",
    module: "Qr",
  },
  {
    title: "charges",
    icon: "BriefcaseIcon",
    route: "charges",
    module: "Cargos",
  },
  {
    title: "employees",
    icon: "UsersIcon",
    route: "employees",
    module: "Empleados",
  },
  {
    title: "clients",
    icon: "UserIcon",
    route: "clients",
    module: "Clientes",
  },
  {
    title: "suppliers",
    icon: "TruckIcon",
    route: "suppliers",
    module: "suppliers",
  },
  {
    title: "categoryProducts",
    icon: "SlidersIcon",
    route: "categoryProducts",
    module: "categoryProducts",
  },
  {
    title: "famcos_products",
    titleSuperAdmin: "famcosAdminProducts",
    icon: "PackageIcon",
    route: "famcosProducts",
    module: "Famcos Productos",
  },
  {
    title: "schools",
    titleSuperAdmin: "famcosAdminSchools",
    icon: "BookOpenIcon",
    route: "schools",
    module: "Colegios",
  },
  {
    title: "products",
    icon: "PackageIcon",
    route: "products",
    module: "Productos",
  },
  {
    title: "inventories",
    icon: "ArchiveIcon",
    route: "inventories",
    module: "inventories",
  },
  {
    title: "services",
    icon: "ToolIcon",
    route: "services",
    module: "Servicios",
  },
  {
    title: "agendaPartial",
    icon: "CalendarIcon",
    route: "agendaPartial",
    module: "Agenda Parcial",
  },
  {
    title: "appointments",
    icon: "ClockIcon",
    route: "appointments",
    module: "Citas",
  },
  {
    title: "productAppointments",
    icon: "CalendarIcon",
    route: "productAppointments",
    module: "Agenda",
  },
  {
    title: "whitelist",
    icon: "ShieldIcon",
    route: "whitelist",
    module: "White List",
  },
  {
    title: "promotions",
    icon: "GiftIcon",
    route: "promotions",
    module: "Promociones",
  },
  {
    title: "preorders",
    titleSuperAdmin: "famcosAdminPreorders",
    icon: "ShoppingCartIcon",
    route: "preorders",
    module: "Pre-órdenes",
  },
  {
    title: "orders",
    icon: "ShoppingBagIcon",
    route: "orders",
    module: "Órdenes",
  },
  {
    title: "chats",
    icon: "MessageSquareIcon",
    route: "chat",
    module: "Conversaciones",
  },
  {
    title: "memberships",
    icon: "CreditCardIcon",
    // module: "Admin Membresías",
    children: [
      {
        title: "membership",
        route: "membership",
        module: "Membresías",
      },
      {
        title: "paymentHistory",
        route: "PaymentHistory",
        module: "Historial de pagos",
      },
      {
        title: "admin_memberships",
        route: "AdminMemberships",
        module: "Admin Membresías",
      },
      {
        title: "admin_paymentHistory",
        route: "AdminPaymentHistories",
        module: "Admin Historial de pagos",
      },
    ],
  },
  {
    title: "referrals",
    icon: "UserPlusIcon",
    route: "referrals",
    module: "Referidos",
  },
  {
    title: "supports",
    icon: "LifeBuoyIcon",
    route: "supports",
    module: "Tickets de soporte",
  },
  {
    title: "logs",
    icon: "ActivityIcon",
    route: "logs",
    module: "Logs del OpenAI",
  },
  {
    title: "templates",
    icon: "FileTextIcon",
    route: "template",
    module: "Plantilla",
  },
  {
    title: "users",
    icon: "UsersIcon",
    route: "users",
    module: "Usuarios",
  },
  {
    title: "profiles",
    icon: "UserCheckIcon",
    route: "profiles",
    module: "Perfiles",
  },
  {
    title: "settings",
    icon: "SettingsIcon",
    module: "Configuraciones",
    children: [
      {
        title: "permissions",
        route: "permissions",
        module: "Permisos",
      },
      {
        title: "companiesTypes",
        route: "companiesTypes",
        module: "Tipos de compañías",
      },
      {
        title: "azureArchitecture",
        route: "azureArchitecture",
        module: "Azure",
      },
      {
        title: "subcriptions",
        route: "subcriptions",
        module: "Suscripciones",
      },
      {
        title: "catalogs",
        route: "catalogs",
        module: "Catálogos",
      },
      {
        title: "landingClients",
        route: "landingClients",
        module: "Clientes web",
      },
      {
        title: "evolutionIntances",
        route: "evolutionIntances",
        module: "Instancias Evolution",
      },
    ],
  },
];
